<template>
  <modal @close="$emit('close')" class="text-sm">
    <p class="text-white flex text-center font-semibold text-xl -mt-4" slot="header">Напомнить <br>
      о регистрации</p>
    <div class="px-8 py-4 text-main-text text-sm">
      <div class="flex flex-col w-full text-sm">
        <p class="font-bold flex mb-3">Выберите время</p>
<!--        <custom-select v-model="remind_time" :options="timeObjects"></custom-select>-->
        <p class="font-bold flex mt-5 mb-3">Выберите способ оповещения</p>
<!--        <custom-select v-model="remind_push" :options="pushObjects"></custom-select>-->
      </div>

      <div class="flex justify-start items-end my-6">
        <label class="flex justify-start mt-1 cursor-pointer text-mxs">
          <span class="mr-3">
            <input class="checkbox" v-model="checked" type="checkbox">
            <span class="checkbox-custom"></span>
          </span> <span>Я соглашаюсь на
            <span class="text-brand-light underline">обработку персональных данных</span> и прочитал
            <span class="text-brand-light underline">пользовательское соглашение</span></span>
        </label>
      </div>
      <button @click="$emit('applyRemind', {time: timeObjects[remind_time-1].value, push: pushObjects[remind_push-1].value})"
        class="flex justify-center items-center mx-auto bg-brand-light rounded-full text-white outline-none hover-up font-semibold w-2/3 h-10 mt-5">
        Напомнить
      </button>
    </div>
  </modal>
</template>

<script>
import ModalMixin from '../../../mixins/modals.js';
// import CustomSelect from './CustomSelect.vue';
import Modal from '@/views/modals/base-modal';
import client from '@/clients/player';
// import Form from 'form-backend-validation';

export default {
  name: 'RemindAboutRegistration',
  props: ['remind_about_registration'],
  mixins: [ModalMixin],
  components: {
    Modal,
    // CustomSelect,
  },
  data() {
    return {
      ext: '',
      show: false,
      loaded: false,
      checked: false,
      // form: new Form({


      // }),
      timeObjects: [
        { id: 1, value: 'За два часа' },
        { id: 2, value: 'За час' },
        { id: 3, value: 'За 30 минут' },
        { id: 4, value: 'За 10 минут' },
      ],
      pushObjects: [
        { id: 1, value: 'По E-mail' },
        { id: 2, value: 'По телефону ' },
        { id: 3, value: 'По E-mail и телефону' },
      ],
      remind_time: '',
      remind_push: '',
    };
  },
  methods: {
  },
};

</script>

<style scoped>
.checkbox {
        display: none;
    }

    .checkbox-custom {
        position: relative;
        width: 20px;
        height: 20px;
        border: 2px solid #ccc;
        border-radius: 3px;

    }

.checkbox-custom,
    .label {
        display: inline-block;
        vertical-align: middle;
        @apply text-xs
    }

    .checkbox:checked + .checkbox-custom::before {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        border-radius: 2px;
        outline: 2px solid #979797;
        border: 2px solid white;
        background-image: url("../../../assets/SVG/modal-tick.svg");

        background-repeat: no-repeat;
        color:#bd006c;
        font-weight: bold;
    }

</style>
